module.exports = __webpack_public_path__ + "media/images/gallery/constellations/gemini/gem_vis-09c1fdfe55dc05b1eb1d70336a744018.jpg";